module.exports = __webpack_public_path__ + "static/media/pharmacodb-logo-capsule.457b3463.png";